// Базовый компонент попапа

const template = /* html */`
        <div class="popup-wrapper">
            <div
                id="overlay"
                class="popup-overlay popup-overlay--visible"
                @click="closable ? $emit('closedPopup') : ''"
            >
            </div>
            <div :class="{'popup': true, 'popup--xl': xl, 'popup--full-mobile' : fullScreenMobile}">
                <a
                    href="#"
                    v-if="closable"
                    class="popup__close"
                    @click.prevent="$emit('closedPopup')"
                >
                    <i class="fa fa-times"></i>
                </a>
                <div
                    class="popup__header"
                    v-if="showHeader || showLogo"
                    :class="{'popup__header--small':smallPopup}"
                >
                    <div
                        v-if="showLogo"
                        class="popup__logo"
                        :class="{'popup__logo--small':smallPopup}"
                    >
                        <img src="/static/i/dadata-logo.svg" alt="DaData.ru">
                    </div>
                    <slot name="header"></slot>
                </div>
                <div class="popup__body" :class="{'popup__body--small':smallPopup}">
                    <slot></slot>
                    <div class="form-group" v-if="showTerms">
                        Регистрируясь, вы принимаете 
                        <a href="/terms" target="_blank">публичную оферту</a>
                    </div>
                </div>
            </div>
        </div>
`;

export default {
    data() {
        return { isDesktop: false };
    },
    setup(props, { slots }) {
        const {
            watch, toRef, ref, provide,
        } = window.Vue;
        const isActive = toRef(props, "isActive");
        const shouldFocus = ref(props.isActive);

        const showHeader = "header" in slots;

        watch(isActive, newVal => {
            shouldFocus.value = newVal;
        });

        provide("shouldFocus", shouldFocus);

        return { showHeader };
    },
    template,
    created() {
        // Отслеживается ширина окна, чтобы попап мог быть закрыт только в моб.устройствах
        // при variant = "closable-fullscreen-mobile"
        const mql = window.matchMedia("(min-width: 972px)");
        this.isDesktop = mql.matches;

        mql.addEventListener("change", e => {
            this.isDesktop = e.matches;
        });
    },
    computed: {
        closable() {
            if (this.variant === "closable") return true;
            return !this.isDesktop;
        },
        fullScreenMobile() {
            return ["non-closable-fullscreen-mobile",
                    "closable-fullscreen-mobile"].includes(this.variant);
        },
    },
    props: {
        showLogo: {
            type: Boolean,
            default: false,
        },
        smallPopup: {
            type: Boolean,
            default: false,
        },
        showTerms: {
            type: Boolean,
            default: false,
        },
        isActive: { type: Boolean },
        xl: {
            type: Boolean,
            default: false,
        },
        variant: {
            type: String,
            default: "closable",
            validator(value) {
                return [
                    "closable",
                    "closable-mobile",
                    "closable-fullscreen-mobile",
                    "non-closable-fullscreen-mobile",
                ].includes(value);
            },
        },
    },
    emits: ["closedPopup"],
    name: "BasePopup",
};
